import styled from "styled-components";

export const ProductCartWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding-bottom: 98px;
`;

export const ProductCartHeaderSelectorWrapper = styled.div<{
  isPickUp: boolean;
  inset: number | null;
}>`
  margin-top: ${(props) => (props.inset ? props.inset + 68 : 68)}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding: 5px;
  width: calc(100% - 32px);
  height: 40px;
  border-radius: 18px;
  background: #f0f0f0;
  position: relative;
  flex-shrink: 0;

  &::before {
    content: "";
    position: absolute;
    top: 5px;
    left: ${(props) => (props.isPickUp ? "5px" : "calc(50% + 2.5px)")};
    width: calc(50% - 7.5px);
    height: calc(100% - 10px);
    background: #6436e7;
    border-radius: 15px;
    transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }
`;

export const ProductCartHeaderSelectorItem = styled.div<{
  isSelected: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;
  height: 100%;
  border-radius: 15px;
  background: transparent;
  color: ${(p) => (p.isSelected ? "#fff" : "#B7B7B7")};
  cursor: pointer;
  position: relative;
  z-index: 2;

  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: scale(1.02);
  }
`;

export const ProductCartListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
  width: 100%;
  margin-bottom: 20px;
  flex-shrink: 0;
`;

export const ProductCartListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0px 16px;
  width: 100%;
  > img {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    object-fit: cover;
    border: 1px solid #f0f0f0;
  }
`;

export const ProductCartItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`;

export const ProductCartItemHeader = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;

  > .box {
    display: flex;
    flex-direction: column;
    gap: 4px;

    > .name {
      color: #000;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    > .price {
      color: #000;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }

  > img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    cursor: pointer;
  }
`;

export const ProductCartListLine = styled.div`
  width: 100%;
  height: 1px;
  background: var(--Black-100, #f0f0f0);
`;

export const ProductCartItemCountWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ProductCartItemCountBox = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--Black-200, #b7b7b7);

  overflow: hidden;
  color: #121212;
  text-overflow: ellipsis;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const ProductCartLine = styled.div`
  width: 100%;
  height: 3px;
  background: var(--Black-100, #f0f0f0);
`;

export const ProductCartMemoWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  flex-shrink: 0;

  > .title {
    color: #000;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
export const ProductCartMemoInputWrapper = styled.div`
  width: 100%;
  height: 94px;
  border-radius: 8px;
  border: 1px solid #f0f1f5;
  background: #fff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const ProductCartMemoInput = styled.textarea`
  width: 100%;
  height: 36px;
  outline: none;
  border: none;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 18.2px */
  letter-spacing: -0.26px;
`;

export const ProductCartMemoInputTextCount = styled.div`
  color: var(--Black-200, #b7b7b7);
  text-align: right;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.26px;
`;

export const ProductCartMileageWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;

  > .title {
    color: #000;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const ProductCartMileageListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const ProductCartMileageListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .product {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: #121212;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .value {
    color: #000;
    text-align: right;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 50%;
  }
`;

export const ProductCartPayBox = styled.div`
  width: 100%;
  height: 98px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.25);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const ProductCartPayBoxContent = styled.div`
  width: calc(100% - 32px);
  height: 48px;
  display: flex;
  margin-top: 15px;

  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #6436e7;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.165px;
`;
